import axios from '@/axios';

export const uploadNotas = (idProduct, formData) =>
    axios.post(`/v2/${idProduct}/excel/notas`, formData);